module.exports = "/_next/static/images/razorpay-7c8844ef782bb82f7edab1ce82910d6c.png";